import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Divider,
  Alert,
  CircularProgress
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { login } from '../api/authService';

export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setErrorMsg('');
    setLoading(true);
    try {
      const response = await login({ dni : email, password });
      const { status, data, error } = response.data;

      if (status) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('uuid', data.uuid);
        localStorage.setItem('fullname', data.fullname);
        localStorage.setItem('dni', data.dni);

        window.location.href = '/dashboard';
      } else {
        setErrorMsg(error?.errorMessage || 'Ocurrió un error desconocido');
      }
    } catch (err: any) {
      setErrorMsg(err.response.data.error.errorMessage || 'Error al conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: 'auto',
        p: 4,
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#fff',
      }}
    >
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        
        Inicia sesión en tu cuenta
      </Typography>

      

      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMsg}
        </Alert>
      )}

      <TextField
        label="Documento de Identidad"
        fullWidth
        required
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <TextField
        label="Contraseña"
        type={showPassword ? 'text' : 'password'}
        fullWidth
        required
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      
      

      <FormControlLabel
        control={<Checkbox defaultChecked />}
        label="Mantenerme conectado en este dispositivo"
        sx={{ mt: 1 }}
      />

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2, backgroundColor: '#000', color: '#fff', fontWeight: 'bold' }}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Iniciar sesión'}
      </Button>

      <Typography variant="body2" mb={2} mt={2}>
        
        <Link component={RouterLink} to="/recuperar-contrasena" color="primary" underline="hover">
          ¿Olvidaste tu contraseña?
        </Link>
      </Typography>

    </Box>
  );
}
